import { magnifyingGlassEffect } from "../utils/magnifying_glass"

if (document.querySelector(".v_mission")) {
  const observerOptions = {
    rootMargin: "-80px"
  }
  magnifyingGlassEffect(observerOptions)
}
